import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import modules from './modules'

Vue.use(Vuex)

let debug = false

if (process.env.VUE_APP_LOCALDEBUG == 1) {
  //const debug = process.env.NODE_ENV !== 'production'
  debug = true
}

export default new Vuex.Store({
  modules,
  actions: {
    reset({ commit }) {
      Object.keys(modules).forEach(moduleName => {
        commit(`${moduleName}/RESET`)
      })
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})